import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import FavouriteProductPageHeader from "../../components/FavouriteProductPageHeader";
import FavouriteProductItem from "../../components/FavouriteProductItem";
import HomePageFooter from "../../components/HomePageFooter";
import RequestProduct from "../../components/FavouriteProductPageLikeRequest";
import styles from "./favouriteproductpage.module.css";
import { useTranslation } from "react-i18next";
import HomePageHeader from "../../components/HomePageHeader";

const products = new Array(31)
  .fill(null)
  .map((_, index) => ({
    id: index + 1,
    img: "path_to_image",
    product_name: `Product ${index + 1}`,
    price: `${index + 1}00,000 đ`,
  }));

const FavouriteProductPage = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const productsPerPage = 5;
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage]);

  const handleClickNext = () => {
    setCurrentPage((prevPage) =>
      Math.min(prevPage + 1, Math.ceil(products.length / productsPerPage))
    );
  };

  const handleClickPrev = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const handlePageClick = (pageNum) => {
    setCurrentPage(pageNum);
  };

  const renderProducts = () => {
    const startIndex = (currentPage - 1) * productsPerPage;
    const currentProducts = products.slice(
      startIndex,
      startIndex + productsPerPage
    );

    return currentProducts.map((product) => (
      <div className={`row mb-4 ${styles.product}`} key={product.id}>
        <FavouriteProductItem product={product} />
      </div>
    ));
  };
  const renderPagination = () => {
    const totalPages = Math.ceil(products.length / productsPerPage);
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
      pages.push(
        <button
          key={i}
          className={`btn btn-link ${styles.paginationButton} ${
            currentPage === i ? styles.activePage : ""
          }`}
          onClick={() => handlePageClick(i)}
        >
          {i}
        </button>
      );
    }

    return (
      <div className={styles.paginationContainer}>
        <button
          className={`btn btn-link ${styles.paginationButton}`}
          onClick={handleClickPrev}
          disabled={currentPage === 1}
        >
          &lt;
        </button>
        {pages}
        <button
          className={`btn btn-link ${styles.paginationButton}`}
          onClick={handleClickNext}
          disabled={currentPage === totalPages}
        >
          &gt;
        </button>
      </div>
    );
  };

  return (
    <div>
      <HomePageHeader />
      <nav
        className={`navbar navbar-expand-lg navbar-light ${styles.bar} px-2 py-1`}
      >
        <h4 className="mx-auto">{t("favourite_product")}</h4>
      </nav>
      <div className="container">
        {renderProducts()}
        <div className={`d-flex justify-content-center ${styles.pagination}`}>
          {renderPagination()}
        </div>
      </div>
      <RequestProduct best_selling_products={products} />
      <HomePageFooter />
    </div>
  );
};

export default FavouriteProductPage;
